// components/ClientRouterSync.tsx
'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

export function useClientRouterSync() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    // The path from the server-rendered page will be the actual file served (e.g., /)
    // The path from window.location.pathname will be the URL in the browser's address bar (e.g., /pricing)
    // If they are different, it means we've been redirected by the server and need to
    // tell the Next.js router to handle the intended URL.
    if (pathname !== window.location.pathname) {
      // Using `replace` is better than `push` here because it doesn't add a new
      // entry to the browser's history. We're just correcting the state.
      router.replace(window.location.pathname);
    }
  }, [pathname, router]);

  return null; // This component renders nothing.
}